
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { contentBlockButtonStyleMap, isValidUrl } from 'fourwaves-shared';
import { TranslateResult } from 'vue-i18n';

@Component
export default class ContentBlockButton extends Vue {
  @Prop({ type: String, required: false }) readonly label!: string;
  @Prop({ type: String, required: false }) readonly url!: string;
  @Prop({ type: String, required: true }) readonly buttonStyle!: string;

  get buttonLabel(): string | TranslateResult {
    return this.label || this.$t('global.learn_more');
  }

  get buttonUrl(): string {
    return isValidUrl(this.url) ? this.url : '';
  }

  get buttonHierarchy(): string {
    return contentBlockButtonStyleMap[this.buttonStyle];
  }
}
